<template>
	<div class="animated fadeIn">
		<b-tabs v-model="activeTab">
			<b-tab title="Предстоящие"></b-tab>
			<b-tab title="Прошедшие">
				<event-list />
			</b-tab>
		</b-tabs>
	</div>
</template>
<script>
import EventList from '@/components/event/event-list'
export default {
	components: {
		'event-list': EventList
	},
	data () {
		return {
			activeTab: 1,
			tabs: {
				0: '',
				1: 'past'
			}
		}
	},
	watch: {
		activeTab: function (value) {
			let path = '/events'
			path = this.tabs[value] === '' ? path + '' : path + '/' + this.tabs[value]
			this.$router.push({path: path})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/event/indexTabs/past.vue